import { render } from "./dsr.vue?vue&type=template&id=f8ec660c&scoped=true"
import script from "./dsr.vue?vue&type=script&lang=js"
export * from "./dsr.vue?vue&type=script&lang=js"

import "./dsr.vue?vue&type=style&index=0&id=f8ec660c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ec660c"]])

export default __exports__